import { createContext, useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { _showStates } from '../../../App';
import { uniqueKey } from '../../common/keys';
import Help from '../../components/help/Help';
import ViewSettingsMenu from '../../viewSettings/ViewSettingsMenu';
import { helpTypes } from '../reducers/HelpReducer';
import { viewSettingsMenuHandlers, viewSettingsMenuInitialState, viewSettingsMenuReducer } from '../reducers/ViewSettingsMenuReducer';
import { SettingParentContext } from './SettingParentContext';
import { useVcmProps } from './useHelpers/useVcmProps';

export const ViewSettingsMenuContext = createContext();

const ViewSettingsMenuProvider = (props) => {

  const { menuTypeKey } = props

  const settingsParentContext = useContext(SettingParentContext)
  const { states } = settingsParentContext ?? {}
  const { appSettings_state } = states ?? {}
  const { helpOn } = appSettings_state ?? {}
  const hvps = [menuTypeKey]

  const vsmProps = useVcmProps(props)

  // local state
  const [_vsmProps, setVsmProps] = useState()

  useEffect(() => {
    if (vsmProps) {
      setVsmProps(vsmProps)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vsmProps]);

  const initState = {}

  const [vsm_state, dispatch] = useReducer(viewSettingsMenuReducer, viewSettingsMenuInitialState(initState));

  const vsm_handlers = useMemo(
    () => viewSettingsMenuHandlers(dispatch),
    [dispatch]
  );

  const { viewItems } = vsm_state

  if (_showStates.any && _showStates.viewSettingsMenu) {
    console.group('--- viewSettingsMenu ---')
    console.log(Object.keys(vsm_state))
    console.log(Object.keys(vsm_handlers))
    console.groupEnd
  }

  useEffect(() => {
    if (vsmProps) {
      vsm_handlers.handleSetViewItems(_vsmProps)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_vsmProps]);

  const vsmProvider = () => <ViewSettingsMenuContext.Provider value={{ vsm_state }}>
    {helpOn && <Help helpType={helpTypes.topics} helpKey={menuTypeKey} hvps={hvps} />}
    <ViewSettingsMenu key={uniqueKey('vsmc', 'vsm', menuTypeKey)} />
  </ViewSettingsMenuContext.Provider>

  return viewItems ? vsmProvider() : <div style={{ padding: '1em' }}>No View Items</div>
}

export default ViewSettingsMenuProvider
